import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { setConfig } from './config';


async function startApp() {
  const res = await fetch(`${process.env.PUBLIC_URL}/config.json`, { cache: "no-store" });
  const config = await res.json();
  setConfig(config);

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/:buildKey" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
}

startApp().catch((err) => {
  console.error("App failed to start:", err);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
